<div class="container-fluid px-5 py-3 py-md-4 footer-section">
  <div class="row justify-content-end row-gap-2">
    <div class="col-12 col-md-6" *ngIf="isLoggedIn">Terms & Conditions</div>
    <div class="col-12 col-md-6 copyright small">Copyright © {{dynamicYear}} Ascendas Services (India) Pvt. Ltd. All rights
      reserved.</div>
  </div>
</div>